var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFfCalendar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 0C7.05228 0 7.5 0.447715 7.5 1V1.5H13.5V1C13.5 0.447715 13.9477 0 14.5 0C15.0523 0 15.5 0.447715 15.5 1V1.5H19C20.1046 1.5 21 2.39544 21 3.5V19C21 20.1046 20.1046 21 19 21H2C0.89544 21 0 20.1046 0 19V3.5C0 2.39543 0.89543 1.5 2 1.5H5.5V1C5.5 0.447715 5.94772 0 6.5 0ZM5.5 3.5H2V7.5H19V3.5H15.5V5C15.5 5.55228 15.0523 6 14.5 6C13.9477 6 13.5 5.55228 13.5 5V3.5H7.5V5C7.5 5.55228 7.05228 6 6.5 6C5.94772 6 5.5 5.55228 5.5 5V3.5ZM19 9.5H2V19H19V9.5ZM4.5 12C4.5 11.4477 4.94772 11 5.5 11H8.5C9.05229 11 9.5 11.4477 9.5 12C9.5 12.5523 9.05229 13 8.5 13H5.5C4.94772 13 4.5 12.5523 4.5 12ZM11.5 12C11.5 11.4477 11.9477 11 12.5 11H15.5C16.0523 11 16.5 11.4477 16.5 12C16.5 12.5523 16.0523 13 15.5 13H12.5C11.9477 13 11.5 12.5523 11.5 12ZM4.5 16C4.5 15.4477 4.94772 15 5.5 15H8.5C9.05229 15 9.5 15.4477 9.5 16C9.5 16.5523 9.05229 17 8.5 17H5.5C4.94772 17 4.5 16.5523 4.5 16ZM11.5 16C11.5 15.4477 11.9477 15 12.5 15H15.5C16.0523 15 16.5 15.4477 16.5 16C16.5 16.5523 16.0523 17 15.5 17H12.5C11.9477 17 11.5 16.5523 11.5 16Z",
    fill: "#A5ACBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFfCalendar);
export default __webpack_public_path__ + "static/media/ff-calendar.93507ab866eb491a17676dccb8db3b0f.svg";
export { ForwardRef as ReactComponent };